module.exports = __webpack_public_path__ + "img/r-183.890ed89c.jpg";